require("../sass/main.scss");
import ReactDOM from "react-dom";
import React from "react";
import { Provider } from "mobx-react";
import ServicePlanStore from "./components/ServicePlan/ServicePlanStore";
import CappedPricingContent from "./components/CappedPriceService/components/CappedPricingContent";

const providerCappedPricingContent = (
  <Provider servicePlanStore={new ServicePlanStore()}>
    <CappedPricingContent />
  </Provider>
);

const cappedPricingFormRoot = document.getElementById("cappedPriceService");
if (cappedPricingFormRoot) {
  ReactDOM.render(providerCappedPricingContent, cappedPricingFormRoot);
}
